module.exports = __webpack_public_path__ + "static/media/ligacupen_small.d80c037b.jpg";